/* tslint:disable */
/* eslint-disable */
/**
 * Vividi Dashboard API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    CrowdSizeHistoryItem,
    CrowdSizeHistoryItemFromJSON,
    CrowdSizeHistoryItemFromJSONTyped,
    CrowdSizeHistoryItemToJSON,
} from './CrowdSizeHistoryItem';

/**
 * 
 * @export
 * @interface CrowdSizeHistoryResponse
 */
export interface CrowdSizeHistoryResponse {
    /**
     * 
     * @type {Array<CrowdSizeHistoryItem>}
     * @memberof CrowdSizeHistoryResponse
     */
    items: Array<CrowdSizeHistoryItem>;
}

export function CrowdSizeHistoryResponseFromJSON(json: any): CrowdSizeHistoryResponse {
    return CrowdSizeHistoryResponseFromJSONTyped(json, false);
}

export function CrowdSizeHistoryResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CrowdSizeHistoryResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(CrowdSizeHistoryItemFromJSON)),
    };
}

export function CrowdSizeHistoryResponseToJSON(value?: CrowdSizeHistoryResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'items': ((value.items as Array<any>).map(CrowdSizeHistoryItemToJSON)),
    };
}

